import { render } from "./AIModelsCard.vue?vue&type=template&id=660c6446&scoped=true"
import script from "./AIModelsCard.vue?vue&type=script&lang=js"
export * from "./AIModelsCard.vue?vue&type=script&lang=js"

import "./AIModelsCard.vue?vue&type=style&index=0&id=660c6446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660c6446"]])

export default __exports__